import { render, staticRenderFns } from "./cqYou.vue?vue&type=template&id=2b08183a"
import script from "./cqYou.vue?vue&type=script&lang=js"
export * from "./cqYou.vue?vue&type=script&lang=js"
import style0 from "./cqYou.vue?vue&type=style&index=0&id=2b08183a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports